import apiClient from "../../../../../services/apiClient";


// statisticsApi.js
export const statisticsApi = {
  // Получение основной информации о посещаемости
  async getGroupAttendance(kgId, groupNumber, period, isArchive) {
    const url = `tabel_group/sum/${kgId}${isArchive ? '?isArchive=true' : ''}`;
    const data = { numberGr: groupNumber, period };
    return await apiClient.post(url, data);
  },

  // Получение временной информации о посещаемости
  async getGroupAttendanceTemp(kgId, groupNumber, period, isArchive) {
    const url = `tabel_group_temp/sum/${kgId}${isArchive ? '?isArchive=true': ''}`;
    const data = { numberGr: groupNumber, period };
    return await apiClient.post(url, data);
  },

  // Получение информации о детях группы
  async getGroupChildren(kgId, groupId, period) {
    const dateTo = new Date(period.split('.')[1], period.split('.')[0]-1, 1, 9, 0, 0).toISOString();
    const dateFrom = new Date(new Date(dateTo).getFullYear(), new Date(dateTo).getMonth() + 1, 0).toISOString();
    
    const url = `kindergartens/${kgId}/children/main_info?groups=${groupId}&date_to=${dateTo}&date_from=${dateFrom}`;
    return await apiClient.get(url);
  }
};